import React from "react";

export default function CanvasMiniature() {
	return (
		<div/>
	)
}